import React from 'react';
import 'date-fns';
import {TextField,} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import FolderSelector from "../../../folders/FolderSelector";

function JournalForm(props) {
  const { item, handleItemChange, folderList, addFolder, validations, classes } = props;

  return (
    <div style={{display:"flex", flexDirection:"column", gap:"1rem", minWidth:'calc(min(18rem, 100%))', flexGrow: 1}}>
      <TextField
        fullWidth
        variant="outlined"
        label="Title"
        value={item.name || ""}
        onChange={(e) => handleItemChange({...item, name: e.target.value})}
        size="small"
        margin="none"
        InputLabelProps={{shrink: true}}
        required
        error={validations.name && !item.name}
      />
      <TextField
        fullWidth
        variant="outlined"
        label="Post"
        multiline minRows={8} maxRows={20}
        value={item.description || ""}
        onChange={(e) => handleItemChange({...item, description: e.target.value})}
        margin="none"
        InputLabelProps={{shrink: true}}
        required
        error={validations.description && !item.description}
      />
      <div className={classes.row}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            inputVariant="outlined"
            variant="inline"
            format="MM/dd/yyyy"
            label="Date"
            size="small"
            margin='none'
            fullWidth
            value={typeof(item.date) === "string" ? item.date.replace(/-/g, '/') : item.date}
            onChange={(newValue) => handleItemChange({...item, date: newValue})}
            required
            error={validations.date && !item.date}
          />
        </MuiPickersUtilsProvider>
        <FolderSelector
          label="Folder"
          margin="none"
          selectedFolder={item.folder}
          folderList={folderList}
          addFolder={addFolder}
          handleFolderSelect={(newVal) => handleItemChange({...item, folder: newVal})}
        />
      </div>
    </div>
  );
}

export default JournalForm;
